export default __webpack_public_path__ + "static/media/thermometer.3f4fcca9.svg";